import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const createValueChain = createAsyncThunk(
  "createValueChain",
  async ({ data, form, history }) => {
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };
    const response = await axiosHttp.post(
      `vc/create`,
      data,
      config
    );

    form.resetFields();
    message.success("Value Chain successfully created!");
    history("/app/organization/value-chain");
    return response.data;
  }
);

const valueChainCreateSlice = createSlice({
  name: "valueChainCreate",
  initialState: {
    isLoading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(createValueChain.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(createValueChain.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(createValueChain.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default valueChainCreateSlice.reducer;